import { RotateCcw } from "lucide-react";

const DOTS = Array.from({ length: 18 }, (_, i) => {
  const a = (i / 18) * Math.PI * 2;
  const r = 110 + (i % 3) * 22;
  return { dx: Math.cos(a) * r, dy: Math.sin(a) * r, d: (i % 6) * 60 };
});

export const Confirmation = ({ name, onReset }) => (
  <div className="flex min-h-[460px] flex-col items-center justify-center text-center" data-testid="lead-confirmation" role="status" aria-live="polite">
    <div className="relative h-[200px] w-[200px]" aria-hidden="true">
      {DOTS.map((p, i) => (
        <span
          key={i}
          className="absolute left-1/2 top-1/2 -ml-1 -mt-1 h-2 w-2 rounded-full bg-[#BCE3D6]"
          style={{ "--dx": `${p.dx}px`, "--dy": `${p.dy}px`, animation: `rl-converge 1.1s ${p.d}ms cubic-bezier(.6,0,.2,1) both` }}
        />
      ))}
      <span className="rl-pulse absolute inset-[46px] rounded-full bg-[#EF9F27]/25" style={{ animationDelay: "1.2s" }} />
      <span className="absolute inset-[62px] flex items-center justify-center rounded-full bg-[#EF9F27] shadow-[0_0_60px_rgba(239,159,39,0.7)]" style={{ animation: "rl-pop .7s 1s both cubic-bezier(.2,.8,.2,1)" }}>
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
          <path d="M5 12.5l4.5 4.5L19 7.5" stroke="#2C2C2A" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="24" strokeDashoffset="24" style={{ animation: "rl-draw .5s 1.5s forwards ease-out" }} />
        </svg>
      </span>
    </div>
    <p className="mt-6 font-mono-data text-[12px] uppercase tracking-[0.2em] text-[#B86E00]">Match avviato</p>
    <h3 className="mt-3 text-[28px] leading-tight tracking-[-0.02em] sm:text-[34px]" data-testid="lead-confirmation-title">
      Richiesta ricevuta{name ? `, ${name}` : ""}.
    </h3>
    <p className="mt-4 max-w-[420px] text-[16px] leading-relaxed text-[#2C2C2A]/80">
      Ti contattiamo entro 24 ore lavorative per fissare la chiamata di 20 minuti. Nessun impegno.
    </p>
    <button type="button" onClick={onReset} className="mt-8 inline-flex items-center gap-2 rounded-full px-4 py-2 text-[14px] font-medium text-[#0F6E56] hover:bg-[#BCE3D6]/40" data-testid="lead-reset-button">
      <RotateCcw size={14} /> Invia un'altra richiesta
    </button>
  </div>
);
